import React from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';

const OrganiserFieldset = ({ formErrors, isLoading }) => (
  <fieldset disabled={isLoading} className="OrganiserFieldset">
    <div className="row">
      <div className="col-12">
        <p>
          These are the contact details we will display on the listings for this event across our network,
          so attendees can contact you with enquiries and{' '}orders
        </p>
      </div>
      <div className="col-12 col-md-6">
        <FormField
          label="Event Organizer Name"
          error={formErrors.get('organiser_title')}
          name="organiser_title"
          component="input"
          placeholder="Business or organization who is organizing the event "
          type="text"
          className="form-control"
          maxLength={75}
          normalize={val => val.substr(0, 75)}
        />
      </div>
      <div className="col-12 col-md-6">
        <FormField
          label="Event Contact Name"
          error={formErrors.get('organiser_name')}
          name="organiser_name"
          component="input"
          type="text"
          className="form-control"
          placeholder="Enter the name of a contact person"
          maxLength={75}
          normalize={val => val.substr(0, 75)}
        />
      </div>
      <div className="col-12 col-md-6">
        <FormField
          label="Email"
          error={formErrors.get('organiser_email')}
          name="organiser_email"
          component="input"
          type="email"
          placeholder="info@myevent.com"
          className="form-control"
        />
      </div>
      <div className="col-12 col-md-6">
        <FormField
          label="Telephone"
          error={formErrors.get('organiser_phone')}
          name="organiser_phone"
          component="input"
          type="text"
          className="form-control"
        />
      </div>
    </div>
  </fieldset>
);

OrganiserFieldset.propTypes = {
  formErrors: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default OrganiserFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/OrganiserFieldset.jsx